import React, { ReactNode, useEffect, useRef, useState } from "react";
import styles from "./MainPage.module.css";
import useWindowDimensions from "../../util/useWindowDimensions";
import { useScrollbarWidth } from "../../util/useScrollbarWidth";
import Image from "../../section/Image";
import "react-image-gallery/styles/css/image-gallery.css";
import Modal from "../../util/Modal";
import Gallery from "../../section/ImageGallery";
import { Section } from "../../../types";

const MainPage = ({
  children,
  data,
}: {
  children?: ReactNode;
  data: Section[];
}) => {
  const { width } = useWindowDimensions();
  const scrollbarWidth = useScrollbarWidth();
  const imageWidth =
    width < 768 ? width / 2.1 : (width - scrollbarWidth - 8 * 10) / 8; // 10px ist der Rand jedes Bildes (5px links und 5px rechts)
  const [selectedImageIndex, setSelectedImageIndex] = useState(-1);
  const imageRef = useRef<HTMLImageElement>(null);
  const centerDivRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (imageRef.current && centerDivRef.current) {
      const imageHeight = imageRef.current.offsetHeight;
      const centerDivHeight = centerDivRef.current.offsetHeight;

      const numRows = Math.ceil(centerDivHeight / imageHeight);
      centerDivRef.current.style.gridRow = `span ${numRows}`;
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      {data.map((image, index) => (
        <Image
          src={image.pictures[0].dataUrl}
          onClick={() => setSelectedImageIndex(index)}
          id={index}
          key={index}
          width={imageWidth}
          blur={!!children}
        />
      ))}
      {!children && selectedImageIndex !== -1 && (
        <Modal onClose={() => setSelectedImageIndex(-1)}>
          <Gallery
            images={data[selectedImageIndex].pictures.map((p) => p.dataUrl)}
            closeGallery={() => setSelectedImageIndex(-1)}
          />
        </Modal>
      )}
      {children && <div className={styles.centerDiv}>{children}</div>}
    </div>
  );
};

export default MainPage;
